<script setup>
import {useDefaultStore} from '@/stores/DefaultStore'
import {storeToRefs} from 'pinia'
import ThePreloader from '@shared-components/ThePreloader.vue'

const {fullPagePreloader} = storeToRefs(useDefaultStore())
</script>

<template>
  <notifications />
  <transition name="fade">
    <the-preloader v-show="fullPagePreloader"></the-preloader>
  </transition>
  <router-view />
</template>

<style lang="scss">
.full-page-preloader {
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: auto;
  z-index: 9999;
}
</style>
